// extracted by mini-css-extract-plugin
export default {"container":"banner-faq_container__iaxh4","perguntas-faq":"banner-faq_perguntas-faq__B1Kiz"};